module.exports = __webpack_public_path__ + "img/im.86c0868f.svg";